var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.alertType)?_c('div',{attrs:{"id":"alert-display"}},[_c('div',{staticClass:"notification",class:_vm.alertClass[_vm.alertType]},[_c('strong',[_vm._v(_vm._s(_vm.alertMessage))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }